import vm from '@/main'

const i18n = param => vm.$t(`_staff.${param}`)
export default () => {
  const column = [
    {
      label: i18n('labelBenefit.benefitWic'),
      field: 'benefitWic',
      dictField: 'benefitWicName',
      formOption: {
        type: 'select',
        dictBizCode: 'benefit_wic',
      },
    },
    {
      label: i18n('labelBenefit.benefitDental'),
      field: 'benefitDental',
    },
    {
      label: i18n('labelBenefit.benefitTermLife'),
      field: 'benefitTermLife',
    },
    {
      label: i18n('labelBenefit.benefitMedicalPlan'),
      field: 'benefitMedicalPlan',
      dictField: 'benefitMedicalPlanName',
      formOption: {
        type: 'select',
        dictBizCode: 'benefit_medical_plan',
      },
    },
    {
      label: i18n('labelBenefit.benefitEnhanceHealthPackage'),
      field: 'benefitEnhanceHealthPackage',
      dictField: 'benefitEnhanceHealthPackageName',
      formOption: {
        type: 'select',
        dictBizCode: 'benefit_enhance_health_package',
      },
    },
    {
      label: i18n('labelBenefit.benefitBondAndOthers'),
      field: 'benefitBondAndOthers',
      dictField: 'benefitBondAndOthersName',
      formOption: {
        type: 'select',
        dictBizCode: 'benefit_bond_and_others',
      },
    },
    {
      label: i18n('labelBenefit.benefitInsuranceInternationalSos'),
      field: 'benefitInsuranceInternationalSos',
      dictField: 'benefitInsuranceInternationalSosName',
      formOption: {
        type: 'select',
        dictBizCode: 'benefit_insurance_international_sos',
      },
    },
    {
      label: i18n('labelBenefit.allowance'),
      field: 'allowance',
    },
    {
      label: i18n('labelBenefit.bonus'),
      field: 'bonus',
    },
    {
      label: i18n('labelBenefit.benefitWellnessClaim'),
      field: 'benefitWellnessClaim'
    }
  ]
  return column
}
